import Component from "flarum/Component";
import icon from "flarum/helpers/icon";
import LoadingIndicator from "flarum/components/LoadingIndicator";
import Uploader from "simple-uploader.js"
export default class UploadButton extends Component {
    
    
    oninit(node) {
    	super.oninit(node);
        // the service type handling uploads
        this.textAreaObj = null;
        // initial state of the button
        this.loading = false;
        this.composer = node.attrs.composer;
        this.uploader = new Uploader({
            target: '/', 
            query: {},
            chunkSize: 1*1024*1024*1024*1,
            testChunks: false,
            method: 'multipart'
        });
        this.subscribe();
    }
    
    /**
     * Show the actual Upload Button.
     *
     * @returns {*}
     */
    view() {
        return m('div',{
            className: 'Button hasIcon elgek-upload-button Button--icon',
            id: 'elgek-upload-button',
            onclick:()=>{
                document.getElementById("elgek-upload-input").click();
            }
        },[
            LoadingIndicator.component({className: 'LoadingIndicator-container--small Button-icon loading'}),
            icon('fa fa-upload', {className: 'Button-icon icon'}),
            m('input',{type:'file',multiple:"multiple",id:"elgek-upload-input",onchange:(e)=>{this.fileAdded(e)}})
        ]);
    }
    
    fileAdded(e){
        
        let file = document.getElementById("elgek-upload-input").files[0];
        if (file.size > (100 * 1024 * 1024)) {
            alert("Max size:100M");
            return;
        }
        
    	document.getElementById("elgek-upload-button").classList.add("loading");
        let that = this;
        that.uploader.addFile(file);
        app.request({
            method: "POST",
            url: app.forum.attribute('apiUrl') + "/elgek/upload-config",
            body: {fileName: file.name}
        })
        .then(function(config) {
        	file.key = config.key;
            let query = {
                'key' : config.key,
                'policy': config.policy,
                'OSSAccessKeyId': config.accessid, 
                'success_action_status' : '200', //让服务端返回200,不然，默认会返回204
                'signature': config.signature,
            };
            that.uploader.opts.query = query;
            that.uploader.opts.target = config.host;
            that.uploader.upload();
        })
        
    }
    subscribe(){
        const that = this;
        this.uploader.on('fileSuccess', function (rootFile, file, message) {
            let bbcode;
            console.log(file);
            const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
			if (validImageTypes.includes(file.fileType)) {
			    that.getHeightAndWidthFromDataUrl(file).then((dimensions)=>{
			        bbcode = "[EImg url="+that.uploader.opts.query.key+" width="+dimensions.width+" height="+dimensions.height+"]";
			        that.composer.editor.insertAtCursor(bbcode + '\n', false);
                    that.uploader.removeFile(file);
                	document.getElementById("elgek-upload-button").classList.remove("loading");
                })
			}else{
				bbcode = "[EFile="+that.uploader.opts.query.key+"]"+file.name+"[/EFile]";
				that.composer.editor.insertAtCursor(bbcode + '\n', false);
                that.uploader.removeFile(file);
            	document.getElementById("elgek-upload-button").classList.remove("loading");
			}
            
        });
        this.uploader.on('fileProgress', function (rootFile, newFile, chunk) {
        	console.log(Number(newFile.progress() * 100).toFixed(2).toString() + "% / " + Number(newFile.averageSpeed / 1024).toFixed(2).toString() + "kb/s");
        });
    }
    
    getHeightAndWidthFromDataUrl(file){
        var _URL = window.URL || window.webkitURL;
        const fileAsDataURL = _URL.createObjectURL(file.file)
        return new Promise(resolve => {
          const img = new Image()
          img.onload = () => {
            resolve({
              height: img.height,
              width: img.width
            })
          }
          img.src = fileAsDataURL
        })
    }
}
